// import external dependencies
import 'jquery';
import Glide from '@glidejs/glide';

import {

  MegaMenu,
  Modal,
  Navigation,
  Accordion,
  LightBox,
  Dropdowns,
  PredictiveText,
  Textfields,
  Textareas,
  Tabs,
  Podcast,

} from 'experience-kit';


// Import everything from autoload
import "./autoload/experienceKit.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import AnimatedTabLine from './animatedTabLine';
import CountryListNav from './countryListNavigation';
// Abe event nav backup
import EventsNav from './event-page-nav';
//import DropdownSelectOptions from './dropdownSelectOptions';
import GetCountries from './getCountries';
import Team from './teamInfo';
import Course from './courseInfo';
import Dictionary from './dictionary';
import PhotoGrid from './photo-grid';
import Carousel from './carousel';
import Analytics from './analytics';
import Cloudsearch from './cloudsearch';
import Research from './research';
import Sustainability from './sustainability';
import MediaPresence from './media-presence';
import ModalMessage from './components/_modalMessage';
import Newsletter from './newsletter';
//import PageLoader from './components/page-loader';
import TabsEvents from './tabs-events';
import OpenPopUps from './open-popups';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

class Main {
  constructor () {
    this.MegaMenu = MegaMenu.init({ initSelector: '.modal' });
    this.modal = Modal.init({ initSelector: '.modal'});
    this.navigation =  Navigation.init({initSelector: '.navigation'});
    this.lightBox = LightBox.init({ initSelector: '.design-lightbox' });
    this.Accordion = Accordion.init({ initSelector: '.accordion' });
    this.textfields = Textfields.init({ initSelector: '.textfield'});
    this.textareas = Textareas.init({ initSelector: '.textarea' });
    this.podcast = Podcast.init({ initSelector: '.podcast' });
    this.tabs = Tabs.init({ initSelector: '.tabs:not(.projects-menu)' });


    // this.Dropdowns = Dropdowns.init({ element: document.querySelector('.dropdown') });
    // this.DropdownsEvents = Dropdowns.init({ element: document.querySelector('.dropdown .dropdown-countries-events') });
    this.photoGrid = new PhotoGrid();
    this.glide = new Glide('.glide');
    this.carou = new Carousel();
    this.analytics = new Analytics();
    this.cloudsearch = new Cloudsearch();
    this.research = new Research();
    this.sustainability = new Sustainability();
    this.mediaPresence = new MediaPresence();
    this.newsletter = new Newsletter();
    this.tabsEvents = new TabsEvents();
    this.OpenPopUps = new OpenPopUps();

    this.dropdowns = Dropdowns.init({
      initSelector: '.dropdown',
      //onChange: this.research.setupOnChangeAdvanced.bind(this.research),
    });

    this.predictiveText = PredictiveText.init({
      initSelector: '.predictiveText.research_PredictiveText',
      searchFunc: this.research.predictiveSearchTerms.bind(this.research),
      onSubmit: this.research.onSubmit.bind(this.research),
      lastItem: {
        div: 'DIV',
        class: 'item item__more',
        link: '#',//window.location.origin + '/research/?q=',
        text: 'View all',
      },
      resultItemOption: {
        div: 'DIV',
        class: 'item',
        callback: this.research.showResearchInfo.bind(this.research),
      },
    });

    this.predictiveTextSustainability = PredictiveText.init({
      initSelector: '.predictiveText.sustainability_PredictiveText',
      searchFunc: this.sustainability.predictiveSearchTerms.bind(this.sustainability),
      onSubmit: this.sustainability.onSubmit.bind(this.sustainability),
      lastItem: {
        div: 'DIV',
        class: 'item item__more',
        link: '#',//window.location.origin + '/research/?q=',
        text: 'View all',
      },
      resultItemOption: {
        div: 'DIV',
        class: 'item',
        callback: this.sustainability.showResearchInfo.bind(this.sustainability),
      },
    });


    this.mediaPredictiveText = PredictiveText.init({
      initSelector: '.predictiveText.media-presence_PredictiveText',
      searchFunc: this.mediaPresence.predictiveSearchMedia.bind(this.mediaPresence),
      onSubmit: this.mediaPresence.onSubmit.bind(this.mediaPresence),
      lastItem: {
        div: 'DIV',
        class: 'item item__more',
        link: '#',
        text: 'View all',
      },
      resultItemOption: {
        div: 'DIV',
        class: 'item',
        callback: this.mediaPresence.showMediaPresenceInfo.bind(this.mediaPresence),
      },
    });

    // this.pageLoader = new PageLoader();
    // Abe event nav backup
    this.EventsNav = new EventsNav();
    // push all instances into this array
    this.pageComponents = [];
    this.init();
  }

  init (){

    //Glide doesn't work well if there are no items
      if( null != document.querySelector(".light-box div.glide__bullets i") ){
        this.glide.mount();

        //Add event listener to each photo so when you click on it the lightbox will show the clicked photo
        var img_links = document.querySelectorAll(".photogrid__item a");
        for( var i = 0; i < img_links.length; i++ ){
          img_links[i].addEventListener('click', function(event){
            var index = event.target.getAttribute("data-index");
            window.ExperienceTheme.glide.update({startAt: index});
          });
        }
      }

    this.pageComponents.push(new GetCountries());
    this.pageComponents.push(new Team());
    this.pageComponents.push(new Course());
    this.pageComponents.push(new Dictionary());
    this.pageComponents.push(new AnimatedTabLine());
    this.pageComponents.push(new CountryListNav());
    this.pageComponents.push(new ModalMessage());

    this.closeVideoModal = document.querySelectorAll('.modal-ek.video .ui-close');
    if( this.closeVideoModal != null ) {
      this.closeVideoModal.forEach( (value) => {
        value.addEventListener('click', () => {
          var video = value.parentNode.querySelector('video');
          if( video != null ) {
              video.pause();
              video.currentTime = 0;
          }

          let iframe = value.parentNode.querySelector('iframe');
          if( iframe != null ) {
            let src = iframe.getAttribute("src");
            iframe.setAttribute('src', '');
            window.setTimeout(() => {
              iframe.setAttribute('src', src);
            }, 500);
          }
        });
      });
    }
  }
}
window.ExperienceTheme = new Main();
window.submitted = function(msg) {
  console.log('submitted');
  console.log(msg);
}
